class FooterNewsletter extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    if (!this.details) return;

    this.summary = this.details.querySelector('summary');
    this.input = this.details.querySelector('.custom-input__field input');

    if (!this.summary || !this.input) return;

    this.boundHandleSummaryClick = this.handleSummaryClick.bind(this);
    this.boundHandleClickOutside = this.handleClickOutside.bind(this);

    this.summary.addEventListener('click', this.boundHandleSummaryClick);
    document.addEventListener('click', this.boundHandleClickOutside);
  }

  handleSummaryClick(event) {
    event.preventDefault();
    this.details.open = true;
    this.input.focus();
  }

  handleClickOutside(event) {
    if (!this.details.contains(event.target) && !this.summary.contains(event.target)) {
      this.details.open = false;
      this.input.blur();
    }
  }

  disconnectedCallback() {
    if (this.summary) {
      this.summary.removeEventListener('click', this.boundHandleSummaryClick);
    }
    document.removeEventListener('click', this.boundHandleClickOutside);
  }
}

customElements.define('footer-newsletter', FooterNewsletter);
